module.exports = __webpack_public_path__ + "assets/img/avatar-s-24.61de186b.jpg";